// ==============================|| AUTH STORAGE ||============================== //

const TOKEN_KEY = 'token';
const USER_KEY = 'user';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function isAuthenticated() {
  return Boolean(getToken());
}

export function setAuth(token, user) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function getRoleName(user) {
  return (user?.role_name || user?.Role?.role_name || '').toUpperCase();
}

export function isSuperAdmin(user) {
  return getRoleName(user) === 'SUPER_ADMIN';
}

export function getDefaultPathForUser(user) {
  const role = getRoleName(user);
  if (role === 'DRIVER') {
    return '/dashboard/driver';
  }
  return '/dashboard/default';
}
